import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateJustificationsActions as PaginateActions } from 'store/ducks/justifications';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  JustificationsList,
  JustificationFilters,
  FindJustifications,
} from 'components/Pages/Justifications';
import { ListingPageHeader, Paginator, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const JustificationsListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('Justifications');

  const {
    data: justifications,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateJustifications);

  const [query, setQuery] = useState<FindJustifications>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.CategoryIcon />}
          title="Justificativas"
          isLoading={loading}
          actions={
            <S.LinkButton to={'/configuracoes/justificativas/criar'} size="small">
              <S.PlusIcon /> Nova justificativa
            </S.LinkButton>
          }
        />
        <JustificationFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <JustificationsList
          justifications={justifications}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
